<template>
  <v-card flat tile class="mb-4">
    <v-toolbar flat>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/val/settings">
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-layout row wrap class="mt-1">
        <v-flex xs9>
          <v-progress-linear v-model="percentagVAL" height="40" :color="statusColor"></v-progress-linear>
        </v-flex>
        <v-flex xs3 class="mt-2">
          <div class="text-xs-center">
            <div v-if="false" class="vocal-activity-value headline ">{{ percentagVAL }}%</div>
            <div class="vocal-activity-value display-2"><span :class="statusColor+'--text'">{{ vocalActivityValue }}</span>
            </div>
            <div class="vocal-activity-label hidden-sm-and-down">{{ vocalActivityValue }} of {{ totalDailyAllotment }}
              Daily Voice Activity Pts</div>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <div class="vocal-activity-label hidden-md-and-up">{{ vocalActivityValue }} of {{ totalDailyAllotment }}
              Daily Voice Activity Points</div>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn round color="primary" to="/val">Add Activity</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  // import GetActivityByUserQuery from '../queries/GetActivityByUserQuery';
  import { ListActivitiesForCurrentUser } from '@/components/queries'
  import AppConst from '../AppConst.js'

  // @TODO: Start JS below.
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        title: 'Voice Activity',
        vocalActivityValue: 0,
        totalDailyAllotment: 0,
        // statusColor: 'success' // @TODO: set boolean instead of string.
      }
    },
    computed: {
      ...mapState(['now']),
      percentagVAL () {
        return this.calActVal()
      },
      statusColor(){
        return this.percentagVAL > 100 ? 'error': 'success'
      }
    },
    methods: {
      async refresh () {
        this.totalDailyAllotment = await this.getTotalDailyAllotment()
        this.vocalActivityValue = await this.getTotaledActivityValue()
        console.log('vocal refresh: totalDailyAllotment', this.totalDailyAllotment)
      },
      async getTotaledActivityValue () {
        try {
          const { data } = await this.$apollo.query({
            variables: {
              actDate: localStorage.currentDate
            },
            query: ListActivitiesForCurrentUser
          })

          const items = data.listActivitiesForCurrentUser.items || []
          const napTotal = items.filter(it => it.activityType === 'NapTaken').length

          const skip = ['VoiceFeeling', 'NapTaken', 'Sick', 'WaterConsumption', 'VoiceCeilingPitch']
          const tempTotalAct = items.filter(it => !skip.includes(it.activityType)).reduce((t, a) => t + a.value, 0)

          const feel = items.filter(it => it.activityType === 'VoiceFeeling').pop() || null
          let napValue = 1
          if (feel) {
            napValue = AppConst.voiceFeelDefaults.find(it => it.text === feel.intensity).napValue
          }
          return Math.max(tempTotalAct - napTotal * napValue, 0)
        } catch (err) {
          console.error(err)
          return 0
        }
      },
      async getTotalDailyAllotment () {
        try {
          const { data } = await this.$apollo.query({
            variables: {
              actDate: localStorage.currentDate
            },
            query: ListActivitiesForCurrentUser
          })
          const items = data.listActivitiesForCurrentUser.items || []
          const feeling = items.find(it => it.activityType === 'VoiceFeeling')
          return (feeling && feeling.value) ? feeling.value : 0
        } catch (err) {
          console.error(err)
          return 0
        }
      },

      calActVal () {
        if (this.totalDailyAllotment === 0) {
          return 0
        } else {
          const temp = Math.floor((this.vocalActivityValue / this.totalDailyAllotment) * 100)
          return temp
        }
      }
    },
    async mounted () {
      this.refresh()

      this.$root.$on('voiceFeelChange', feel => {
        this.totalDailyAllotment = feel.value
        // await this.refresh();
      })

      this.$root.$on('napChange', await this.refresh)
      this.$root.$on('DateChange', await this.refresh)
    },
    beforeDestroy () {
      this.$root.$off('voiceFeelChange')
      this.$root.$off('DateChange')
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/home/VocalActivityHome.vue